module.exports = __webpack_public_path__ + "static/img/bottom_QRcode.ef05d7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom_QRcode.png
// module id = Qjm2
// module chunks = 1